<template>
  <dotcom-icon
    class="search"
    name="magnifying-glass"
    art="light"
    data-track-trigger
    data-track-as="search"
    data-track-text="icon"
    color="--c-primary-neutral-1"
    hover-color="--c-primary-color-2"
    tabindex="0"
    @click="searchClicked"
    @keydown="onKeydown"
  />
</template>

<script>
export default {
  name: 'Search',
  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },
  methods: {
    searchClicked() {
      window.dispatchEvent(new CustomEvent('sanitas-open-search-view'))
    },
    onKeydown(e) {
      if (e.keyCode === 13) {
        this.searchClicked()
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.search {
  font-size: 16px;

  &:hover {
    cursor: pointer;
  }
}

@media (--lg) {
  .search {
    font-size: 24px;
  }
}
</style>
